// extracted by mini-css-extract-plugin
export var aircallIframe = "_ep-3";
export var fabContainer = "_ep-5";
export var fabRinging = "_ep-6";
export var loadingOverlay = "_ep-4";
export var pulse = "_ep-7";
export var widgetContent = "_ep-2";
export var widgetPanel = "_ep-0";
export var widgetPanelExpanded = "_ep-1";